import { z } from "zod";

/**
 * Schema for Chat.settings Json field.
 *
 * Contains per-chat configuration used by the backend AI pipeline and
 * the embed/API deployment flows. Frontend-only settings (UI theme, branding,
 * suggestedMessages, etc.) are not validated here — this schema covers only the
 * fields the backend reads at runtime.
 */
export const ChatSettingsSchema = z.object({
  /** Deprecated: describe mode toggle (Plan/Flow feature removed) */
  describeMode: z.boolean().optional(),
  /** Default command/skill key pre-selected in the chat input */
  chatDefaultCommand: z.string().optional(),
  /** Arbitrary embed metadata passed through from the embed SDK */
  embedData: z.record(z.string(), z.unknown()).optional(),
  /** Whether to inject additional context into the AI prompt */
  addContext: z.boolean().optional(),
  /** Deployment type that originated this chat (EMAIL, SLACK, EMBED, etc.) */
  deploymentType: z.string().optional()
});

// Type is defined in shared/domain/chat/chat.types.ts — not duplicated here.
// Use ChatSettings from @nexus/types for typing; use ChatSettingsSchema for runtime validation.
